import { Component } from '@angular/core';

@Component({
    selector: 'op-product-transport-content',
    templateUrl: './transport-content.component.html'
})
export class TransportContentComponent  {
}
